module.exports = __webpack_public_path__ + "static/IMG-20200906-WA0045-e3cce4622bcea246f4111ae0e9fc7967.jpg";